<template>
  <v-row class="desposite-dashboadpage keep-safe-dashboard">
    <v-col xs="12" md="12">
      <v-row>
        <v-col xs="8" md="8">
            <ul class="breadcrumbs-list">
              <a  @click="backButton"><li>KeepSafe</li></a>
              <a><li>&nbsp;>&nbsp;My WILL</li></a>
              <li>&nbsp;>&nbsp;Latest WILL</li>
            </ul>
            <div class="head-text">
              <h1>My WILL</h1>
            </div>
        </v-col> 
      </v-row>
      <template>
        <v-card class="tab-card bg-dot-img">
          <v-tabs v-model="tab">
            <v-tabs-slider></v-tabs-slider>
            <v-tab href="#tab-1" class="tabs-box" >
              Latest WILL
            </v-tab>
            <v-tab href="#tab-2" class="tabs-box">
              Signed WILL
            </v-tab>
          </v-tabs>
          <v-tabs-items class="tabs-content" xs="8" md="8" v-model="tab">
            <v-tab-item value="tab-1">
              <template>
                <v-card class="manage-box">
                  <v-container grid-list-xl class="member-container" >
                    <v-layout row wrap>
                      <v-flex class="cardbox">
                        <v-card  elevation="8" v-for="will in latwills" :key="will.ksid">
                          <v-container pb-4 grid-list-xl >
                            <v-layout row wrap class="user-detailboxmain">
                              <div class="overline">
                                  <v-img v-if="will.ksid" max-height="32" max-width="40" src="../../assets/images/willkeepsafe1.png"></v-img>
                                  <v-img v-else max-height="32" max-width="40" src="../../assets/images/willkeepsafe0.png"></v-img>
                              </div>
                              <v-flex class="user-detailbox">
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      <p>WILL For</p>
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-flex class="userdetail">
                                  <v-layout row wrap>
                                    <v-flex md6 sm6 xs12>
                                      <p class="font-weight-medium user-icon">{{will.name}}</p>
                                    </v-flex>
                                    <v-flex md6 sm6 xs12>
                                      <div class="date-box">
                                        <p style="text-align:left !important">Date of {{will.type == 'created' ? 'Creation':'Amendment'}}</p>
                                        <p class="font-weight-regular">{{will.updated_at| formatDate("DD MMM, yyyy")}}</p>
                                      </div>
                                    </v-flex>
                                    <v-flex class="upload-img" v-if="!will.file">
                                      <v-img
                                        max-height="22"
                                        max-width="18"
                                        :src="webIcon + 'yellow_upload.png'"
                                        @click="uploadDoc(will.id,will.member_id, 'VAS')"
                                      >
                                      </v-img>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-flex>
                              <v-col class="memberbox-editbox" v-if="will.file">
                                <v-menu bottom left offset-y>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      outlined fab
                                      color="#F19700"
                                      v-bind="attrs"
                                      v-on="on"
                                    >
                                      <v-img max-height="20" max-width="20" :src="three_dots" :lazy-src="three_dots"></v-img>
                                    </v-btn>
                                  </template>
                                  <v-list>
                                    <v-list-item>
                                      <v-list-item-title>
                                        <v-btn @click="viewDoc(will.file)">
                                          <v-img
                                          max-height="20"
                                          max-width="20"
                                          :src="view_pic"
                                          :lazy-src="view_pic"
                                          ></v-img>View
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item>
                                      <v-list-item-title>
                                        <v-btn @click="deleteDoc(will.ksid)">
                                          <v-img
                                          max-height="23"
                                          max-width="19"
                                          :src=" delete_pic"
                                          :lazy-src=" delete_pic"
                                          ></v-img>Delete
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                              </v-col>
                            </v-layout>
                          </v-container>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </template>
            </v-tab-item>
            <v-tab-item value="tab-2">
              <template>
                <v-card class="manage-box">
                  <v-container grid-list-xl class="member-container" >
                    <v-layout row wrap>
                      <v-flex class="cardbox">
                        <v-card  elevation="8" v-for="will in prevwills" :key="will.ksid">
                          <v-container pb-4 grid-list-xl >
                            <v-layout row wrap class="user-detailboxmain">
                              <div class="overline">
                                  <v-img v-if="will.ksid" max-height="32" max-width="40" src="../../assets/images/willkeepsafe1.png"></v-img>
                                  <v-img v-else max-height="32" max-width="40" src="../../assets/images/willkeepsafe0.png"></v-img>
                              </div>
                              <v-flex class="user-detailbox">
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      <p>WILL For</p>
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-flex class="userdetail">
                                  <v-layout row wrap>
                                    <v-flex md6 sm6 xs12>
                                      <p class="font-weight-medium user-icon">{{will.name}}</p>
                                    </v-flex>
                                    <v-flex md6 sm6 xs12>
                                      <div class="date-box">
                                        <p style="text-align:left !important">Date of {{will.type == 'created' ? 'Creation':'Amendment'}}</p>
                                        <p class="font-weight-regular">{{will.updated_at| formatDate("DD MMM, yyyy")}}</p>
                                      </div>
                                    </v-flex>
                                    <v-flex class="upload-img" v-if="!will.file">
                                      <v-img
                                        max-height="22"
                                        max-width="18"
                                        :src="webIcon + 'yellow_upload.png'"
                                        @click="uploadDoc(will.id,will.member_id, 'signed')"
                                      >
                                      </v-img>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-flex>
                              <v-col class="memberbox-editbox" v-if="will.file">
                                <v-menu bottom left offset-y>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      outlined fab
                                      color="#F19700"
                                      v-bind="attrs"
                                      v-on="on"
                                    >
                                      <v-img max-height="20" max-width="20" :src="three_dots" :lazy-src="three_dots"></v-img>
                                    </v-btn>
                                  </template>
                                  <v-list>
                                    <v-list-item>
                                      <v-list-item-title>
                                        <v-btn @click="viewDoc(will.file)">
                                          <v-img
                                          max-height="20"
                                          max-width="20"
                                          :src="view_pic"
                                          :lazy-src="view_pic"
                                          ></v-img>View
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item>
                                      <v-list-item-title>
                                        <v-btn @click="deleteDoc(will)">
                                          <v-img
                                          max-height="23"
                                          max-width="19"
                                          :src=" delete_pic"
                                          :lazy-src=" delete_pic"
                                          ></v-img>Delete
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                              </v-col>
                            </v-layout>
                          </v-container>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </template>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </template>
    </v-col>  
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Upload Doc</span>
        </v-card-title>
        <form
          ref="form"
          id="upload_deposit_keep_safe_form"
          lazy-validation
        >
          <v-card-text >
            <v-container>
              <v-row >
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                >
                <v-file-input
                  name="file"
                  id="fileUpload"
                  ref="file"
                  @change="handleFileUpload()"
                  label="Choose Doc"
                  accept=".pdf"
                ></v-file-input>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions >
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="dialog = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="submit"
            >
              Upload
            </v-btn>
          </v-card-actions>
        </form>  
      </v-card>
    </v-dialog> 
  </v-row>

</template>
<script>
  import { Auth } from "aws-amplify";
  import axios from "axios";
  export default {
    data () {
      return {
        tab: null,
        latwills:[],
        prevwills:[],
        three_dots:process.env.VUE_APP_ROOT_ICONS_URL + 'three_dots.png',
        edit_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'edit.png',
        delete_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'delete.png',
        view_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'view.png',
        webIcon:process.env.VUE_APP_ROOT_ICONS_URL,
        dialog:false,
        componentKey:0,
        curr_type:''
      }
    },
    mounted() {
      Auth.currentAuthenticatedUser({
        bypassCache: false
      })
      .then(user => {
        this.getWills();
      })
    },
    methods:{
      getWills(){
        let formdata = {
          aws_cognito_id:atob(localStorage.getItem('cognito_idp')),
        }
        axios.post(process.env.VUE_APP_ROOT_API + "get-keepsafe-wills", formdata)
        .then((response) => {
          let allwills = response.data.data;
          let signedwills = response.data.signed_wills;
          this.latwills = allwills.slice(0, 4);
          this.prevwills = signedwills.slice(0, 4);
        })
      },
      backButton(){
        this.$router.push({ name: 'KeepSafeCategory'}).catch(()=>{});
      },
      viewDoc(url){
        window.open(url,'_blank');
      },
      uploadDoc(id,mid,type ){
        this.dialog = true;
        this.will_id = id;
        this.member_id = mid;
        this.curr_type = type
      },
      deleteDoc(item){
        swal.fire({
          icon:'warning',
          title: "Are You Sure!",
          text:"You want to delete this doc?",
          showCancelButton: true,
          confirmButtonColor: `#051d42`,
          confirmButtonText: `YES`,
          cancelButtonColor: `#f19700`,
          will_id:0,
          member_id:0
        })
        .then(result => {
          if (result.isConfirmed) {
            let formdata = {
              member_id:item.member_id, 
              will_id:item.id,
              module_type:item.module_type,
              aws_cognito_id:atob(localStorage.getItem('cognito_idp'))
            }
            axios.post(process.env.VUE_APP_ROOT_API + "del-keepsafe-will", formdata)
            .then((response) => {
              swal.fire({
                icon:'success',
                title:'Success',
                text:'Document deleted successfully.'
              })
              this.getWills();
            })
          }
        });
      },
      handleFileUpload(){
        this.file = document.getElementById("fileUpload").files[0]
        if(this.file.type != 'application/pdf'){
          swal.fire({
            title: 'Invalid File',
            text: "Only pdf file is allowed.",
            icon: 'error',
            showCancelButton: false,
            confirmButtonColor: '#051d42',
            confirmButtonText: 'OK',
          });
          this.componentKey++;
          this.file = '';
        }
      },
      submit(e) {
        let formdata    = new FormData();
        formdata.append("aws_cognito_id", atob(localStorage.getItem('cognito_idp')));
        formdata.append("doc_file", this.file);
        formdata.append("will_id", this.will_id);
        formdata.append("member_id", this.member_id);
        formdata.append("type", this.curr_type);
        
        axios.post(
          process.env.VUE_APP_ROOT_API+'upload-will-keep-safe-doc',
          formdata,{
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
        .then((response) => {
          if (response.data.status == 'success') {
            this.getWills();
            this.dialog = false
            Toast.fire({
              icon: 'success',
              title: 'Doc uploaded successfully'
            });
          }
          else {
            swal.fire({
              title: 'Error!',
              text: response.data.message,
              icon: 'error'
            });
          }
        })
        .catch(() => {
            this.$loading(false);
        });
      }
    }
  }
</script>